module.exports = __webpack_public_path__ + "static/img/rank_22.4002838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_22.png
// module id = T6te
// module chunks = 1